// removed by extract-text-webpack-plugin
module.exports = {"reportModal":"qempo_ReportModal_reportModal-1ASfQwi","orange":"qempo_ReportModal_orange-Isfeoa6","lightBlue":"qempo_ReportModal_lightBlue-21IdttE","alterContent":"qempo_ReportModal_alterContent-vzxCnzU","reportForm":"qempo_ReportModal_reportForm-3iudLW4","row":"qempo_ReportModal_row-26mCNXN","label":"qempo_ReportModal_label-3x_H9Zx","confirm":"qempo_ReportModal_confirm-1AP2WY5","modalLoading":"qempo_ReportModal_modalLoading-1yPfE20"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/report/components/ReportModal.scss
// module id = 1779
// module chunks = 0